import { UseFormSetValue } from "react-hook-form";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { FormValues } from "@/interfaces/searchBlock";
import styles from "./CompanyRateCodeBlock.module.scss";
import { ActiveCompanyRateCode } from "./activeCompanyRateCode/ActiveCompanyRateCode";
import { CompanyRateCodeModalTrigger } from "./companyRateCodeModalTrigger/CompanyRateCodeModalTrigger";

export type CompanyRateCodeBlockProps = {
  initialCode?: string;
  setValue: UseFormSetValue<FormValues>;
};
export const CompanyRateCodeBlock = ({
  initialCode,
  setValue,
}: CompanyRateCodeBlockProps) => {
  const [companyRateCode, setCompanyRateCode] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    setCompanyRateCode(initialCode);
  }, [initialCode]);

  const updateCompanyRateCode = (code: string | undefined) => {
    setValue("companyRateCode", code);
    setCompanyRateCode(code);
  };

  const [displayCompanyRateCode, setDisplayCompanyRateCode] =
    useState<boolean>(false);
  const { query } = useRouter();
  useEffect(() => {
    if (
      (query.displayCompanyRateCode !== undefined &&
        query.displayCompanyRateCode === "true") ||
      query.companyRateCode !== undefined
    ) {
      setDisplayCompanyRateCode(true);
    }
  }, [query]);

  return (
    <>
      {displayCompanyRateCode && (
        <div className={styles.companyRateCodeBlock}>
          {companyRateCode === undefined ? (
            <CompanyRateCodeModalTrigger
              updateCompanyRateCode={updateCompanyRateCode}
            ></CompanyRateCodeModalTrigger>
          ) : (
            <ActiveCompanyRateCode
              code={companyRateCode}
              updateCompanyRateCode={updateCompanyRateCode}
            ></ActiveCompanyRateCode>
          )}
        </div>
      )}
    </>
  );
};
